module.exports = __webpack_public_path__ + "static/media/car.00aa5f8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/car.png
// module id = 623
// module chunks = 0